<template>
  <section
    class="h-screen relative flex flex-col justify-end bg-cover bg-no-repeat bg-center bg-fixed text-white p-8"
    :style="{ backgroundImage }"
  >
    <div
      class="absolute top-0 left-0 w-full h-full bg-gradient opacity-50"
    ></div>
    <div class="relative flex flex-col mx-auto h-full justify-center container">
      <h1
        class="text-h-orange font-headline md:text-5xl text-3xl my-4 md:my-0 font-bold md:leading-normal"
      >
        {{ hero.title }}
      </h1>
      <h2 class="md:text-4xl text-2xl md:leading-normal font-headline">
        {{ hero.subTitle }}
      </h2>
      <p class="md:w-1/3 leading-relaxed">{{ hero.caption }}</p>

      <ro-h-button :color="'white'" :href="'#contact'">Get a Quote</ro-h-button>
    </div>
    <div
      class="absolute sm:w-2/3 xl:w-auto flex flex-row right-0 bottom-0 mr-12 md:mr-24 -mb-24"
    >
      <img class="w-11/12" src="/assets/hero-group.png" />
    </div>
  </section>
</template>

<script>
import RoHButton from "@/components/RoHButton.vue";

export default {
  name: "RoHHero",
  components: { RoHButton },
  props: {
    hero: {
      type: Object
    }
  },
  computed: {
    backgroundImage() {
      return 'url("' + this.hero.img + '")';
    }
  },
  methods: {}
};
</script>

<style scoped>
/* .bg-gradient {
  background: linear-gradient(
    90deg,
    rgba(0, 136, 180, 1) 0%,
    rgba(21, 77, 95, 1) 47%,
    rgba(234, 116, 21, 0.65) 100%
  );
} */

</style>
